import { Node } from 'reactflow';
import useStore from '@components/MainStage/store';
import { useProject } from '@context/Project/ProjectProvider';

export const useSourceNode = () => {
  const canvasNode = useStore((state) =>
    state.nodes.find((node: Node) => node.selected),
  );
  const { drawer } = useProject();

  const payloadNode = drawer?.payload?.node as Node | undefined;

  if (payloadNode && canvasNode?.id === payloadNode.id) {
    return canvasNode;
  }

  return payloadNode ?? canvasNode;
};

export default useSourceNode;
